export default "__VITE_ASSET__CywbzWkS__"